"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultBlockStructure = exports.getDefaultTemplateStructure = void 0;
const getDefaultTemplateStructure = (templateType) => {
    const template = new templateType();
    return template.defaultStructure;
};
exports.getDefaultTemplateStructure = getDefaultTemplateStructure;
const getDefaultBlockStructure = (blockType) => {
    const block = new blockType();
    return block.defaultStructure;
};
exports.getDefaultBlockStructure = getDefaultBlockStructure;
//# sourceMappingURL=campaignTemplate.js.map